import { Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';

import { useSupplierDetailsContext } from './context';

export const SupplierInfo = () => {
    const { data } = useSupplierDetailsContext();

    return (
        <Card>
            <CardHeader className="p-4 sm:p-6">
                <CardTitle>Supplier Information</CardTitle>
            </CardHeader>
            <CardContent className="grid grid-cols-1 gap-3 p-4 pt-0 sm:grid-cols-2 sm:p-6 sm:pt-0">
                <div className="min-w-0">
                    <span className="text-sm text-muted-foreground">Name</span>
                    <p className="break-words">{data?.data?.name}</p>
                </div>
                <div className="min-w-0">
                    <span className="text-sm text-muted-foreground">Email</span>
                    <p className="break-all">{data?.data?.email}</p>
                </div>

                <div className="min-w-0">
                    <span className="text-sm text-muted-foreground">Phone</span>
                    <p className="break-words">{data?.data?.phone_number}</p>
                </div>
                <div className="min-w-0">
                    <span className="text-sm text-muted-foreground">
                        Address
                    </span>
                    <p className="break-words">{data?.data?.address}</p>
                </div>

                <div className="flex flex-col items-start justify-start gap-0.5">
                    <span className="block text-sm text-muted-foreground">
                        Brand
                    </span>
                    <p>{data?.data?.brand_id ?? 'N/A'}</p>
                </div>

                <div className="flex flex-col items-start justify-start gap-0.5">
                    <span className="block text-sm text-muted-foreground">
                        Member Since
                    </span>
                    <p>
                        {new Date(data?.data?.created_at ?? '').toDateString()}
                    </p>
                </div>
            </CardContent>
        </Card>
    );
};

SupplierInfo.displayName = 'SupplierInfo';
